export interface PatchModel {
  operation: number;
  path: string;
  value: string;
}
